<div class="user-cell">
    <img
        class="avatar"
        *ngIf="country && country !== '-'"
        [src]="imgSrc || emptyFlagSrc"
        [alt]="country"
        width="24"
        height="16"
        decoding="async" />
    <span class="user-name">{{ country }}</span>
</div>